export default __webpack_public_path__ + "static/media/vcode.bcc8cfb7.png";